//angular imports
import { signal, Signal, WritableSignal } from "@angular/core";

//local imports
import { IListItem, ListItem, Messenger } from "@app/shared";
import { AbstractRoomNavModel, SelectRoomMessage } from "@app/catalog-common";
import { RoomModel } from "@app/catalog";

export class RoomsNavModel 
  extends AbstractRoomNavModel<RoomModel> {
    
  public override allowMultiSelect?: WritableSignal<boolean> = signal<boolean>(false);
  
 constructor(
    messenger: Messenger,
    items: Signal<RoomModel[]>
  ) {
    super(messenger, items);
  }

  public select(item: IListItem): void {
    const navItem = item as ListItem<RoomModel>;
    this.messenger.send(new SelectRoomMessage(navItem.value));
  }
}